import { POPUP_PAGE_NAME, PopupDataType } from '@/components/GlobalSocketPopup/types.ts'

// 定义Message接口类型，避免静态导入@tencentcloud/chat
export interface Message {
  ID: string
  payload?: {
    extension?: string
    data?: string
  }
}

export const useIMWebSocket = () => {
  // 接收消息
  const onMessage = async (callback: (data: Message[]) => void) => {
    // 动态导入TUIChatEngine，避免阻塞首屏加载
    const { default: TUIChatEngine, StoreName, TUIStore } = await import('@tencentcloud/chat-uikit-engine')
    TUIStore.watch(StoreName.CHAT, {
      newMessageList: (list?: any) => {
        if (list && Array.isArray(list) && list.length > 0) {
          callback(list)
        }
      },
    })
  }

  // im返回数据转换deliveryPage为前端真实路由
  const checkPageStrToRouteName = (message: PopupDataType): PopupDataType => {
    const newMessage = JSON.parse(JSON.stringify(message)) // 深拷贝
    if (!newMessage?.attr?.deliveryPage) return newMessage
    // 将 deliveryPage 按逗号分割成数组，并用 POPUP_PAGE_NAME 映射转换
    const pageKeys = newMessage.attr.deliveryPage.split(',').filter(Boolean)
    const mappedPages = pageKeys.map((key: string) => POPUP_PAGE_NAME[key as keyof typeof POPUP_PAGE_NAME]).filter(Boolean)
    // 替换回转换后的值
    newMessage.attr.deliveryPage = mappedPages.length ? mappedPages.join(',') : ''
    return newMessage
  }

  // 消息检查，判断是否满足弹窗
  const checkMessage = (message: Message) => {
    if (!message.payload) return {}
    const payload = message.payload?.extension || message.payload?.data
    if (!payload) return {}
    const payloadInfo = { ...JSON.parse(payload), ID: message.ID, isExpired: false }
    // 真实调试时判断条件改成3
    if (payloadInfo?.scene !== 3) return {}
    // 0：默认 1：订单 2：套餐  3：弹窗
    return {
      ...checkPageStrToRouteName(payloadInfo),
    }
  }

  return {
    onMessage,
    checkMessage,
  }
}
